import { Grid } from "@mui/material";
import React, { useState, useCallback, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import { updateMainHeader } from "../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../StateManagement/actions";

export const ExpenseList: React.FC<any> = React.memo(() => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  const [isPopupOpen, setPopupOpen] = useState(false);
  
  const selectedIdRef = useRef<string>("");

  useEffect(() => {
    updateMainHeader("Expense List");
    breadCrumbsStore.updateBreadCrumbs([{ "Expense List": "/expense/list" }]);
  }, []);

  const source = {
    url: "Vyapar/Expense/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
  };

  const handleAction = useCallback(async (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/expense/edit/${row.id}`);
    } else if (action === "Delete") {
      selectedIdRef.current = row.id;
      setPopupOpen(true);
    }
  }, [navigate]);

  const columns: IColumns[] = [
    { header: "Expense No", fieldName: "expenseNo", },
    { header: "Expense Category", fieldName: "expenseCategory", },
    { header: "Expense Date", fieldName: "date", type: "date", },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: handleAction
    },
  ];

  const handleClick = useCallback(() => {
    navigate("/expense");
  }, [navigate]);

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="expenseGrid"
            title="Expense List"
            columns={columns}
            source={source}
            searchBox={{ fieldName: 'billNo' }}
            addButton={{ label: "Add New Expense", color: "secondary" }}
            onAddButtonClick={handleClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
        <ConfirmationPopup
          type="DELETE"
          apiUrl="Vyapar/Expense"
          id={selectedIdRef.current}
          confirmMessage="Are you sure you want to delete this expense?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={(data: any) => {
            dispatch(resetDataComponent("expenseGrid"));
            showMessage(data?.success ? data.message : data.message || "Delete failed", data?.success ? "success" : "error");
          }}
        />
      </Grid>
    </Grid>
  );
});

export default ExpenseList;